import { Component, Input, OnInit } from '@angular/core';
import { LibraryService } from 'src/app/core/services/library/library.service';
import { CheckoutWizardSettingsService } from 'src/app/shared/state/checkout-wizard-settings/checkout-wizard-settings.service';
import { CheckoutWizard, CheckoutWizardStore } from 'src/app/shared/state/checkout-wizard/checkout-wizard.store';
import { CompanyStore } from 'src/app/shared/state/company/company.store';

@Component({
    standalone: false,
    selector: 'app-checkout-wizard',
    templateUrl: './checkout-wizard.component.html',
    styleUrls: ['./checkout-wizard.component.scss'],
})
export class CheckoutWizardComponent implements OnInit {
    @Input() checkoutData?: CheckoutWizard;
    @Input() isAppointment: boolean = false;

    arePointsEnabled: boolean = false;

    constructor(
        private checkoutWizardQuery: CheckoutWizardStore,
        private checkoutWizardSettingsService: CheckoutWizardSettingsService,
        private companyQuery: CompanyStore,
        private libraryService: LibraryService
    ) { }

    ngOnInit(): void {
        this.arePointsEnabled = this.companyQuery.getValue().clinicPoints;
    }

    /**
     * Forma la cuantía final a mostrar en total a pagar
     * @returns 
     */
    getTotalAmount() {
        let totalAmount = this.checkoutData!.totalAmount;

        if(this.checkoutData?.usePoints) {
            totalAmount = this.checkoutData.points.totalDiscountAmount;
        }

        if(this.isAppointment && this.checkoutData?.payDeposit) {
            totalAmount = this.checkoutData.deposit.totalDepositAmount;
        }

        return totalAmount;
    }

    /**
     * Forma el texto final a mostrar en total a pagar según si hay anticipos o no
     * @returns 
     */
    getTotalLabel() {
        let text = '';

        text = this.libraryService.getLabel('lbl_total_to_pay');

        if (this.checkoutData?.advance) {
            text += ' (' + this.libraryService.getLabel('lbl_advance') + ')';
        }

        return text;
    }

    /**
     * Actualiza el valor de payDeposit en la store
     */
    onPayDepositChange() {
        this.checkoutData!.payDeposit = !this.checkoutData?.payDeposit;
        this.checkoutData!.usePoints = false;
        this.checkoutWizardQuery.update({ ...this.checkoutData });
        this.checkoutWizardSettingsService.createUrlCheckoutByAppointment(this.checkoutData!.payDeposit);
    }

    /**
     * Actualiza el valor de usePoints en la store
     */
    onUsePointsChange() {
        this.checkoutData!.usePoints = !this.checkoutData?.usePoints;
        this.checkoutData!.payDeposit = false;
        this.checkoutWizardQuery.update({ ...this.checkoutData });
    }
}
